import axiosInstance from "@API/axios";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setUser } from "@Redux/userSlice";
import { useNavigate } from "react-router";
import { USER_LOGIN_URL } from "@API/APIRoutes";
import { home } from "../AppRoutes/DefaultRoutes";

const useLogin = (userInput) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    const login = async () => {
      setError(false);
      setLoading(true);
      try {
        const response = await axiosInstance.post(USER_LOGIN_URL, {
          email: userInput.email,
          password: userInput.password,
        });
        dispatch(
          setUser({
            email: userInput.email,
            username: response.data.username,
            roles: response.data.roles,
            isLogged: true,
            userId: response.data.userId,
          })
        );
        setLoading(false);
        navigate(home);
      } catch (error) {
        setError(true);
        setLoading(false);
      }
    };

    if (userInput) {
      login();
    }
  }, [userInput, dispatch, navigate]);
  return { loading, error };
};
export default useLogin;
